import React, { PropsWithChildren } from "react";
import { Provider } from "mobx-react";
import type { IAppStores } from "./AppMaster";
import { HeaderComponent } from "./header/HeaderComponent";
import { RichToolTipBaseComponent } from "./rich-tooltip/RichToolTipBaseComponent";
import { CookieBannerComponent } from "./cookie-banner/CookieBannerComponent";

interface IAppComponentProps {
    appStores: IAppStores;
}

export class AppComponent extends React.Component<PropsWithChildren<IAppComponentProps>> {
    componentDidMount() {
        const { heartBeatStore } = this.props.appStores;

        heartBeatStore.start();
    }

    componentWillUnmount() {
        const { heartBeatStore } = this.props.appStores;

        heartBeatStore.stop();
    }

    render() {
        const { appStores, children } = this.props;

        return (
            <Provider {...appStores}>
                <RichToolTipBaseComponent />
                <HeaderComponent />
                {children}
                <CookieBannerComponent />
            </Provider>
        );
    }
}
